import axios from 'axios';

const DELETED_PROJECT_MESSAGE = 'This project has been deleted.';
const DELETED_BATCH_MESSAGE = 'This batch belongs to a deleted project.';

function extractDetail(error: unknown): string | null {
  if (!axios.isAxiosError(error)) {
    return null;
  }
  const detail = error.response?.data?.detail;
  if (typeof detail === 'string' && detail.trim()) {
    return detail.trim();
  }
  if (Array.isArray(detail) && detail.length > 0) {
    const first = detail[0];
    if (typeof first === 'object' && first && 'msg' in first) {
      return String((first as { msg?: string }).msg ?? '');
    }
  }
  return null;
}

export function isDeletedResourceError(error: unknown): boolean {
  if (!axios.isAxiosError(error) || error.response?.status !== 409) {
    return false;
  }
  const detail = extractDetail(error);
  if (!detail) {
    return false;
  }
  const normalized = detail.toLowerCase();
  return (
    normalized.includes('project has been deleted') ||
    normalized.includes('project is deleted') ||
    normalized.includes('batch belongs to a deleted project')
  );
}

export function getDeletedResourceMessage(error: unknown): string {
  const detail = extractDetail(error);
  if (detail && isDeletedResourceError(error)) {
    return detail;
  }
  return DELETED_BATCH_MESSAGE;
}

export function deletedProjectMessage(): string {
  return DELETED_PROJECT_MESSAGE;
}

export function deletedBatchMessage(): string {
  return DELETED_BATCH_MESSAGE;
}
